/**
 * 警告 ⚠️
 * 由于运维环境此项目的 node 版本过低，无法注入环境变量
 * 所以这里还是用了傻逼的域名判断
 * 后续会升级运维系统的 node 版本支持环境变量
 *
 *  啊这： 外面2017年写的代码可以注入变量为什么这里不可以？？？（process.env.NODE_ENV === 'production'）， 为了不翻车，现在也通过host判断 （2022-04-08）
 * @export
 * @return {*} 
 */
const prodHost = {
  'm.lizhiweike.com' : true,
  'm1.lizhiweike.com' : true,
}
export function isProduction() {
  return !!prodHost[window.location.hostname]
}
const ua = navigator.userAgent.toLocaleLowerCase()
// 判断是不是手机微信
export const isMobileWeChat = /micromessenger/.test(ua) && !/windowswechat|macwechat/.test(ua)


// WEBPACK FOOTER //
// ./src/core/env.js